import { Button, Flex, IconButton, Popover, Text, Box, ScrollArea } from '@radix-ui/themes';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { CloseIcon, EmailIcon } from 'shared/icons';
import { Candidate } from '../types';

function JobApplicantCoverLetterView({ candidate }: { candidate: Candidate }) {
   const [open, setOpen] = useState(false);

   if (!candidate.coverletter?.description) {
      return null;
   }

   return (
      <Popover.Root
         open={open}
         onOpenChange={(o) => {
            setOpen(o);
         }}
      >
         <Popover.Trigger>
            <Button variant="surface" color="blue" highContrast>
               <EmailIcon />
               Супровідний лист
            </Button>
         </Popover.Trigger>
         <Popover.Content width="360px">
            <Flex justify="between" pb="3">
               <Text color="gray">{candidate.coverletter.title}</Text>
               <Popover.Close>
                  <IconButton
                     color="gray"
                     variant="ghost"
                     radius="full"
                     size="1"
                     style={{ padding: 1 }}
                  >
                     <CloseIcon width={14} height={14} />
                  </IconButton>
               </Popover.Close>
            </Flex>

            <ScrollArea style={{ height: 100 }}>
               <Box pr="5">
                  <Text size="3">{candidate.coverletter.description}</Text>
               </Box>
            </ScrollArea>
            
         </Popover.Content>
      </Popover.Root>
   );
}

export const JobApplicantCoverLetter = observer(JobApplicantCoverLetterView);
